<div class="content-banner" *ngIf="content">
  <div class="content-banner__panel-image">
    <figure>
      <air-focal-image [isCropped]="true" [image]="content.image"></air-focal-image>
    </figure>
  </div>
  <div class="content-banner__panel-content">
    <div class="content-banner__text">
      <h1>{{ content.title }}</h1>
      <h3>{{ content.subtitle }}</h3>
      <div [internalInnerHtml]="content.body" [userEventSource]="userEventSource"></div>
    </div>
    <div class="content-banner__cta button__group" *ngIf="content.link">
      <a *ngFor="let link of content.link" class="button button--cta" [airLink]="link" [userEventSource]="userEventSource">
        {{ link.label }}
      </a>
    </div>
  </div>
</div>
